"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _tab["default"];
  }
});
Object.defineProperty(exports, "ControlledTabs", {
  enumerable: true,
  get: function get() {
    return _controlledTabs["default"];
  }
});
exports["default"] = void 0;

var _uncontrolledTabs = _interopRequireDefault(require("./uncontrolled-tabs"));

var _tab = _interopRequireDefault(require("./tab"));

var _controlledTabs = _interopRequireDefault(require("./controlled-tabs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _uncontrolledTabs["default"];
exports["default"] = _default;